import { AppServerErrorModel } from "../../model"

export class AppServerError extends Error {
    errData: AppServerErrorModel

    constructor(data: AppServerErrorModel) {
        super(data.message)

        this.errData = data
    }
}